import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import { makeSelectValuesTimesheetEntryValue } from 'services/timesheetTimesheetEntriesForm/selectors';
import TimeOptions from '../../../../../../../../components/TimeOptions';
import TableCellRenderDropdown from '../TableCellRenderDropdown';

// Selectors

interface Props {
    startTime?: ?string;
}

export class EndTimeTableCellRenderDropdown extends React.PureComponent<Props> {
    render() {
        const { startTime } = this.props;
        return (
            <TimeOptions isEnd startTime={startTime}>
                <TableCellRenderDropdown {...this.props} />
            </TimeOptions>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    startTime: makeSelectValuesTimesheetEntryValue('startTime')
});

export default connect(mapStateToProps)(EndTimeTableCellRenderDropdown);
